import type { IPaymentItem } from "@/data/model/Order";
import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";

import { Component } from "@/shared/elements/Component";
import { DiscountUtil } from "@/shared/utils/DiscountUtil";
import { toMoney } from "@/shared/utils/format";

import { PaymentItemOptionGroup } from "@/operator/elements/PaymentItemOptionGroup";

export class PaymentItem extends Component {
    public readonly paymentItem: IPaymentItem;
    public readonly displayPrice: boolean;

    constructor(orderItem: IPaymentItem, displayPrice: boolean = false) {
        super();
        this.paymentItem = orderItem;
        this.displayPrice = displayPrice;

        this.$element = this.drawElement();
    }

    protected drawElement() {
        const paymentItem = this.paymentItem;

        // draw order item fields
        const $element = $('<div class="main-item item" />');

        if (paymentItem.isCancelled) {
            $element.addClass("cancelled");
        }

        const $head = $('<div class="head" />').appendTo($element);

        if (paymentItem.isCancelled) $element.addClass("cancelled");

        const $quantity = $('<div class="quantity" />').appendTo($head);
        if (paymentItem.cancelledQuantity > 0)
            $quantity.append(`<span class="cancelled">${paymentItem.quantity}x</span>`);

        if (paymentItem.currentQuantity > 0)
            $quantity.append(`<span>${paymentItem.currentQuantity}x</span>`);

        $head.append(`<div class="main-name name">${this.getDisplayName()}</div>`);

        if (this.displayPrice) {
            if (this.paymentItem.hasDiscount && !this.paymentItem.isCancelled && !this.paymentItem.isZeroPriceArticle) {
                const icon = DiscountUtil.getDiscountIcon(this.paymentItem.lastDiscountType);
                $head.append(`<div class="price has-discount">
                    <div class="price-before-discount" style="color: #fd397a; text-decoration: line-through;">
                        <span class="discount-type">
                            <i class="${icon}"></i>
                        </span>
                        ${this.getDisplayPrice()}
                    </div>
                    <div class="price-after-discount">
                        ${toMoney(this.paymentItem.currentTotalAmountAfterDiscount, true)}
                    </div>
                </div>`);
            } else {
                $head.append(`<div class="price">${this.getDisplayPrice()}</div>`);
            }
        }

        // // draw option groups
        if (paymentItem.options.length) {
            const $subContainer = $('<div class="subs" />').appendTo($element);
            for (const optionGroup of paymentItem.options) {
                PaymentItemOptionGroup.render($subContainer, optionGroup, false, this.displayPrice);
            }
        }

        return $element;
    }

    private getDisplayName() {
        return getNameInLocationLanguage(this.paymentItem, true);
    }

    private getDisplayPrice() {
        if (this.paymentItem.isZeroPriceArticle) return "";

        return toMoney(
            this.paymentItem.isCancelled ? this.paymentItem.totalAmount : this.paymentItem.currentTotalAmount,
            true
        );
    }

    public static render(
        $appendToTarget: JQuery,
        paymentItem: IPaymentItem,
        displayPrice: boolean = false
    ): PaymentItem {
        const component = new PaymentItem(paymentItem, displayPrice);
        component.renderTo($appendToTarget);

        return component;
    }
}
